import { FormSectionWrapper } from "./FormSectionWrapper"
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';

const FormatSelect = ({ formik, id, isReturnShipmentTab }) => {
    const formatTypeField = isReturnShipmentTab ? `returnData.shipAlerts[${id}].notificationFormatType` : `shipAlerts[${id}].notificationFormatType`;
    return (
        <Form.Select
            name={formatTypeField}
            {...formik.getFieldProps(formatTypeField)}
        >
            <option value='TEXT'>Email (Plain text)</option>
            {/* <option value='HTML'>Email (HTML)</option> */}
        </Form.Select>
    )
}

const EmailInput = ({ formik, id, isReturnShipmentTab }) => {
    const emailField = isReturnShipmentTab ? `returnData.shipAlerts[${id}].emailAddress` : `shipAlerts[${id}].emailAddress`;
    return (
        <Form.Control
            name={emailField}
            type='text'
            {...formik.getFieldProps(emailField)}
        />
    )
}

const NotificationCheck = ({ formik, id, notificationEventType, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const notificationEventField = isReturnShipmentTab ? `returnData.shipAlerts[${id}].notificationEventType` : `shipAlerts[${id}].notificationEventType`;
    const handleNotificationCheckChange = (e) => {
        const eventsArray = [...values.shipAlerts[id].notificationEventType];
        const containsValue = eventsArray.includes(notificationEventType);
        formik.handleChange(e);
        if (containsValue) {
            const newArray = eventsArray.filter((i) => i !== notificationEventType);
            formik.setFieldValue(notificationEventField, newArray);
        } else {
            const newArray = [...eventsArray, notificationEventType];
            formik.setFieldValue(notificationEventField, newArray);
        }
    }

    return (
        <Form.Check
            type='checkbox'
            name={notificationEventField}
            checked={values.shipAlerts[id].notificationEventType.includes(notificationEventType)}
            {...formik.getFieldProps(notificationEventField)}
            onChange={(e) => handleNotificationCheckChange(e)}
        />
    )
}

const tableRowData = [
    { title: 'Sender', id: 'sender' },
    { title: 'Recipient', id: 'recipient' },
    { title: 'Broker', id: 'broker' },
    { title: 'Other 1', id: 'other1' },
    { title: 'Other 2', id: 'other2' }
]

export const ShipAlert = ({ formik, isReturnShipmentTab }) => {
    return (
        <FormSectionWrapper title='FedEx ShipAlert'>
            <Table>
                <thead>
                    <tr>
                        <th></th>
                        <th>Format</th>
                        <th>Email address</th>
                        <th>Shipment notification</th>
                        <th>Tendered notification</th>
                        <th>Exception notification</th>
                        <th>Delivery notification</th>
                        <th>Estimated delivery notification</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRowData.map((i) => (
                        <tr key={i.id}>
                            <th>{i.title}</th>
                            <td><FormatSelect formik={formik} id={i.id} isReturnShipmentTab={isReturnShipmentTab} /></td>
                            <td><EmailInput formik={formik} id={i.id} isReturnShipmentTab={isReturnShipmentTab} /></td>
                            <td><NotificationCheck formik={formik} id={i.id} notificationEventType='ON_SHIPMENT' isReturnShipmentTab={isReturnShipmentTab} /></td>
                            <td><NotificationCheck formik={formik} id={i.id} notificationEventType='ON_TENDER' isReturnShipmentTab={isReturnShipmentTab} /></td>
                            <td><NotificationCheck formik={formik} id={i.id} notificationEventType='ON_EXCEPTION' isReturnShipmentTab={isReturnShipmentTab} /></td>
                            <td><NotificationCheck formik={formik} id={i.id} notificationEventType='ON_DELIVERY' isReturnShipmentTab={isReturnShipmentTab} /></td>
                            <td><NotificationCheck formik={formik} id={i.id} notificationEventType='ON_ESTIMATED_DELIVERY' isReturnShipmentTab={isReturnShipmentTab} /></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <br />
            <Form.Group className='form-group'>
                <Form.Label>Add personal message (character limit 120)</Form.Label>
                <Form.Control
                    name={isReturnShipmentTab ? 'returnData.personalMessage' : 'personalMessage'}
                    as='textarea'
                    rows={3}
                    maxLength={120}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.personalMessage' : 'personalMessage')}
                />
            </Form.Group>
        </FormSectionWrapper>
    )
}